interface CognitoError {
  code: string;
  message: string;
  name: string;
}

const getCognitoError = (error: any) => {
  const err: CognitoError = error;
  return err.code;
};

export default getCognitoError;
